import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import DarkModeToggle from './components/DarkModeToggle';

app.initializers.add('zr/dark-mode-toggle', () => {
    // Apply dark mode on initial load before rendering
    const applyInitialDarkMode = () => {
        const stored = localStorage.getItem('zr-dark-mode');
        let isDark;

        if (stored !== null) {
            isDark = stored === 'true';
        } else {
            isDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        }

        if (isDark) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.add('light-mode');
        }
    };

    applyInitialDarkMode();

    // Add toggle button to header
    extend(HeaderSecondary.prototype, 'items', function (items) {
        items.add(
            'darkModeToggle',
            <DarkModeToggle />,
            15 // Priority - higher numbers appear more to the left
        );
    });
});
